module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-f8ec62040460da6fe281c36b43d230f2.webp";